import type { Entity, EntityType, Persisted } from '@tunasong/schemas'
import type { StoredEntityUpload } from './upload-types.js'
import { getEntityTypeFromMime } from '@tunasong/models'

/**
 * Strip a trailing audio file extension (.mp3 / .wav, case-insensitive) from a
 * filename so the user-visible entity title doesn't carry the filesystem
 * extension. The manifest accepts more audio extensions than this regex
 * matches (.ogg, .m4a, .aac, .mp4, .webm, .flac); only the two called out by
 * the originating ticket are stripped here. Extend the alternation if other
 * extensions show up as user complaints.
 *
 * @see https://www.notion.so/3538e623975c81af9e59dd6c11736e53
 */
const audioExtensionPattern = /\.(mp3|wav)$/i
export const stripAudioExtension = (name: string): string => name.replace(audioExtensionPattern, '')

export const blobUploadToTemporaryEntity = ({
  blobUpload,
  userId,
}: {
  blobUpload: StoredEntityUpload
  userId: string
}): Persisted<Entity> => {
  const type = (blobUpload.type as EntityType) ?? getEntityTypeFromMime(blobUpload.blob.type)
  if (!type) {
    throw new Error(`Cannot upload a file with mime type ${blobUpload.blob.type}`)
  }
  return {
    id: blobUpload.id,
    parentId: blobUpload.parentId ?? undefined,
    name: blobUpload.name,
    type,
    storageUrls: {
      // @todo this expires, but we are not using it...
      expiresAtISODateTime: new Date().toISOString(),
      url: URL.createObjectURL(blobUpload.blob),
    },
    userId,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  }
}
